import { render, staticRenderFns } from "./ProductBrand.vue?vue&type=template&id=d1403c0c&"
import script from "./ProductBrand.vue?vue&type=script&lang=js&"
export * from "./ProductBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports